// extracted by mini-css-extract-plugin
export var avatarContainer = "_4k-1";
export var largeAvatarContainer = "_4k-2";
export var smallAvatarContainer = "_4k-0";